import * as GQL from "src/types/graphql";

type FormSchoolRank = {
  form: { status: GQL.form_status_enum };
  offers: { status: GQL.offer_status_enum; expires_at: string | null }[];
};

type FormSchool = {
  schoolId: uuid | null;
};

export function canClearOfferExpiration(
  formSchoolRanks: FormSchoolRank[],
  formSchools: FormSchool[]
): boolean {
  if (formSchools.some((appSchool) => !appSchool.schoolId)) {
    return false;
  }

  return formSchoolRanks.every((rank) => {
    return rank.offers[0]?.expires_at != null;
  });
}
